import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import TemporaryIllnessService from "../../../services/TemporaryIllnessService";
import { TemporaryIllness } from "../../../models";
import Container from "../../../components/container";
import TemporaryIllnessesTable from "./ui/temporary-illnesses-table";
import TemporaryIllnessesTableSkeleton from "./skeletons/temporary-illnesses-table-skeleton";

export default function TemporaryIllnessesPage(){
    const [searchParams] = useSearchParams();
    const api = new TemporaryIllnessService();
    const [items, setItems] = useState<TemporaryIllness[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchItems();
    }, [searchParams.get("reload")]);

    const fetchItems = async () => {
        try{
            const data = await api.getTemporaryIllnesses();
            setItems(data);
        }catch(err){
            console.error("Error fetching temporary illnesses:", err);
        }finally{
            setLoading(false);
        }
    };

    return (
        <div className="w-full">
            <div className="flex w-full items-center justify-between">
                <h1 className={` text-2xl`}>Temporary Illnesses</h1>
            </div>
            {loading ? <TemporaryIllnessesTableSkeleton /> : <TemporaryIllnessesTable items={items} loading={loading} />}
        </div>
    );
}
